<template>
	<div class="page-index-mobile column-me row-center" v-if="isMobile"></div>
	<div ref="carouselFull" class="page-index column-me row-center" v-else>
		<div class="all">
			<toubu></toubu>
			<div class="one">
				<img src="../../assets/img/teamMien.png" class="imgBg" />
			</div>
			<div class="two">
				<div class="two1">我的团队</div>
				<div class="two2">TEAM INTRODUCTION</div>
				<div class="two3">
					博软科技利用先进的互联网技术，打破原有的行业运营模式，将发展过程中积累的技术和业务经验转化和应用于信息化整合
					平台中，为企业提供现代化营销新平台。作为软件开发、网站建设与网络推广行业专家，企业不断引进大量技术人才，短短
					几年时间，从十几人的小团队，发展成为以青岛为中心、北京、西安、深圳、为多个分部，一千余人的强大技术支持团队。
					为博软品牌在互联网行业长期保持领先地位提供了坚实的基础。
				</div>
				<div class="two3"></div>
			</div>
			
			<div class="three">
				<div class="three1">团队风采</div>
				<div class="three2">TEAM ELEGANT DEMEANOUR</div>
				<div class="three3" v-for="i in fengcaiList" :key="i.id" v-if="nameType == i.name">
					<div class="three31"></div>
					<div class="three32">
						<div class="three321">
							<div class="threePP">
								<img src="../../assets/chenggong/arrises.png" />
								<div class="threeP">{{ i.abbreviation }}</div>
							</div>

							<div class="three3211">
								<div class="three32112"></div>
								<div class="three32113">{{ i.name }} {{ i.en_name }}</div>
								<div class="three32114"></div>
							</div>
						</div>
						<div class="three323"></div>
						<div class="three322" v-if="i.appearance">
							<img width="100%" :src="i.appearance" />
						</div>
					</div>
					<div class="three34">
						<div class="three341">
							<div><img :src="i.team_picture[0]" /></div>
							<div><img :src="i.team_picture[2]" /></div>
						</div>
						<div class="three342">
							<div><img :src="i.team_picture[1]" /></div>
							<div><img :src="i.team_picture[3]" /></div>
						</div>
					</div>
					<div class="three31"></div>
				</div>
				<div class="five">
					<div style="display:flex;justify-content:center;">
						<div class="five1" v-for="i in fengcaiList" :key="i.name">

							<div style="cursor: pointer;" @click="clickType(i.name)">
								<img class="five11" src="../../assets/chenggong/fl_s.png" width="100px" height="100px"
									v-if="nameType == i.name" /> <!-- 选择 -->
								<img class="five11" src="../../assets/chenggong/fl_n.png" width="100px" height="100px"
									v-else /> <!-- 不选择 -->
								<div class="five12">{{i.name}}</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="four" style="margin-bottom: 0;">
				<div class="three1">团队成员</div>
				<div class="three2">TEAM MEMBERS</div>
			
				<div class="four4s">
					<div v-for="(item,index) in arraySrcs" :key="index" class="srcList">
						<el-image :src="item.img_url" :preview-src-list="arraySrcLists" fit="cover">
						</el-image>
						<div class="name">{{item.name}}</div>
						<div class="position">{{item.position}}</div>
					</div>
				</div>
			</div>
			
			<div class="four five">
				<div class="three1">团建活动</div>
				<div class="three2">TEAM BUILDING</div>

				<div class="four4">
					<!-- <div v-for="(item,index) in arraySrc" :key="index" class="srcList">
						<el-image :src="item.img" :preview-src-list="arraySrcList" fit="cover">
						</el-image>
					</div> -->
					
					<div class="srcBox srcBoxLeft">
						<el-image :src="arraySrc[0].img" :preview-src-list="arraySrcList" fit="cover" class="onesrc">
						</el-image>
						<el-image :src="arraySrc[1].img" :preview-src-list="arraySrcList" fit="cover" class="twosrc">
						</el-image>
						<el-image :src="arraySrc[2].img" :preview-src-list="arraySrcList" fit="cover" class="threesrc">
						</el-image>
						<el-image :src="arraySrc[4].img" :preview-src-list="arraySrcList" fit="cover" class="foursrc">
						</el-image>
					</div>
					<div class="srcBox srcBoxCen">
						<el-image :src="arraySrc[5].img" :preview-src-list="arraySrcList" fit="cover" class="onesrc">
						</el-image>
					</div>
					<div class="srcBox srcBoxRight">
						<el-image :src="arraySrc[3].img" :preview-src-list="arraySrcList" fit="cover" class="onesrc">
						</el-image>
						<el-image :src="arraySrc[6].img" :preview-src-list="arraySrcList" fit="cover" class="twosrc">
						</el-image>
					</div>
					
					
					
					<!-- <div class="four42"></div>
					<div class="four41">
						<div class="four411">
							<img :src="huodong0" />
							<img :src="huodong1" />
						</div>
						<div class="four412" style="height:42.5%">
							<img :src="huodong2" />
							<img :src="huodong3" />
						</div>
					</div>
					<div class="four43">
						<div class="four412" style="height:100%">
							<img :src="huodong4" />
						</div>
					</div>
					<div class="four44">
						<div class="four412">
							<img :src="huodong5" class="huodong5" />
						</div>
						<div class="four411">
							<img :src="huodong6" />
						</div>
					</div>
					<div class="four42"></div> -->
				</div>
			</div>

			<dibu></dibu>
		</div>
	</div>
</template>

<script>
	import Toubu from "@/components/header.vue";
	import Dibu from "@/components/footer.vue";
	export default {
		data() {
			return {
				isMobile: this.$store.state.isMobile === 1,
				jianjie: "",
				fengcai: "",
				fengcaiList: [],
				xuanze: "",
				xuanzexinxi: "",
				nameType: "",
				teamPicture: [],
				// 团建活动
				huodong: "",
				huodong0: "",
				huodong1: "",
				huodong2: "",
				huodong3: "",
				huodong4: "",
				huodong5: "",
				huodong6: "",
				arraySrc: [],	//团队图片
				arraySrcList: [],	//团队图片
				arraySrcs: [],	//团队图片
				arraySrcLists: [],	//团队图片
			};
		},
		components: {
			Toubu,
			Dibu
		},
		computed: {
			windowChange() {
				return this.$store.state.isMobile;
			},
		},
		watch: {
			windowChange: function(newVal, oldVal) {
				this.isMobile = newVal === 1;
			},
			// xuanze: function() {
			// 	if (this.fengcai) {
			// 		this.fengcai.forEach((a) => {
			// 			if (a.abbreviation == this.xuanze) {
			// 				this.xuanzexinxi = a;
			// 			}
			// 		});
			// 	}

			// 	console.log("a", this.xuanzexinxi);
			// },
		},
		mounted() {
			this.xuanze = "市场";
			this.$get(this.$host + "/index/About/aboutTeam").then((res) => {
				console.log("团队风采", res);
				this.fengcaiList = res.data.position;
				this.teamPicture = res.data.position.team_picture;
				this.nameType = res.data.position[0].name;
				console.log(this.nameType, '158');
				console.log(this.fengcaiList, '159')
				
				this.arraySrc = res.data.team_activity;
				for (var i=0;i<res.data.team_activity.length;i++){
					this.arraySrcList.push(res.data.team_activity[0].img);
					this.arraySrcList.push(res.data.team_activity[1].img);
					this.arraySrcList.push(res.data.team_activity[5].img);
					this.arraySrcList.push(res.data.team_activity[3].img);
					this.arraySrcList.push(res.data.team_activity[2].img);
					this.arraySrcList.push(res.data.team_activity[4].img);
					this.arraySrcList.push(res.data.team_activity[6].img);
				}
				// console.log(this.arraySrcList,'184')
				// console.log(this.arraySrc,'180')
				
				// this.huodong0 = res.data.team_activity[0].img;
				// this.huodong1 = res.data.team_activity[1].img;
				// this.huodong2 = res.data.team_activity[2].img;
				// this.huodong3 = res.data.team_activity[3].img;
				// this.huodong4 = res.data.team_activity[4].img;
				// this.huodong5 = res.data.team_activity[5].img;
				// this.huodong6 = res.data.team_activity[6].img;
			});
			
			this.$get(this.$host + "/index/About/getMember").then((res) => {
				this.arraySrcs = res.data;
				for (var i=0;i<res.data.length;i++){
					this.arraySrcLists.push(res.data[i].img_url)
				}
			});
		},
		methods: {
			clickType(name) { //点击切换类型
				this.nameType = name;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.one {
		width: 100vw;

		// height: 600px;
		// background-image: url("../../assets/img/teamMien.png");
		// background-size: 100% 100%;
		.imgBg {
			width: 100vw;
		}
	}

	.two {
		height: 488px;
		width: 100vw;

		.two1 {
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #000000;
			margin-top: 70px;
			text-align: center;
		}

		.two2 {
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #666666;
			margin-top: 30px;
			text-align: center;
		}

		.two3 {
			margin: 0 auto;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #565656;
			margin-top: 59px;
			// margin-left: 15%;
			// margin-right: 15%;
			line-height: 48px;
			max-width: 1294px;
		}
	}

	.three {
		height: 960px;
		width: 100vw;
		background: #2868b7;
		padding-top: 60px;
		position: relative;

		.three1 {
			height: 40px;
			line-height: 40px;
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #ffffff;
			text-align: center;
		}

		.three2 {
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #ffffff;
			text-align: center;
			margin-top: 29px;
		}

		.three3 {
			// max-width: 1294px;
			height: 590px;
			display: flex;
			margin-top: 70px;

			.three31 {
				flex: 1.3;
			}

			.three32 {
				flex: 1;
				// margin-left: 20px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;

				.three321 {
					height: 30%;
					display: flex;
					align-items: center;

					.three3211 {
						height: 100%;

						.three32111 {
							font-size: 24px;
							font-family: Arial;
							font-weight: 400;
							color: #ffffff;
							margin-bottom: 17px;
						}

						.three32112 {
							height: 1px;
							background: #9EC4F3;
							margin-bottom: 17px;
							margin-top: 56px;
						}

						.three32113 {
							font-size: 24px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #ffffff;
							margin-bottom: 17px;
						}

						.three32114 {
							height: 1px;
							background: #9EC4F3;
						}
					}

					.threePP {
						position: relative;

						.threeP {
							position: absolute;
							left: 40%;
							top: 26%;
							font-size: 72px;
							font-family: Corbel;
							font-weight: 400;
							color: #ffffff;
						}

						img {}
					}
				}

				.three322 {
					// height: 69%;
					height: 400px;
					width: 402px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.three323 {
					height: 10%;
				}
			}

			.three33 {
				flex: 1;
				margin-left: 20px;

				.three331 {
					height: 35%;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.three332 {
					height: 60%;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.three333 {
					height: 5%;
				}
			}

			.three34 {
				// flex: 1;
				display: flex;
				margin-left: 24px;

				.three341 {

					// height: 20%;
					div:nth-child(1) {
						width: 420px;
						height: 240px;
						overflow: hidden;
						margin-bottom: 20px;

						img {
							width: 420px;
							height: 240px;
							transition: all 0.6s;
						}

						img:hover {
							transform: scale(1.4);
						}
					}

					div:nth-child(2) {
						width: 420px;
						height: 330px;
						overflow: hidden;

						img {
							width: 420px;
							height: 330px;
							transition: all 0.6s;
						}

						img:hover {
							transform: scale(1.4);
						}
					}
				}

				.three342 {
					margin-left: 20px;

					div:nth-child(1) {
						width: 420px;
						height: 355px;
						margin-bottom: 20px;
						overflow: hidden;

						img {
							width: 420px;
							height: 355px;
							transition: all 0.6s;
						}

						img:hover {
							transform: scale(1.4);
						}
					}

					div:nth-child(2) {
						width: 420px;
						height: 215px;
						margin-bottom: 20px;
						overflow: hidden;

						img {
							width: 420px;
							height: 215px;
							transition: all 0.6s;
						}

						img:hover {
							transform: scale(1.4);
						}
					}
				}

				.three343 {
					height: 35%;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.three344 {
					height: 5%;
				}
			}
		}

		.five {
			position: absolute;
			left: 0;
			right: 0;
			margin: auto;
			top: 887px;

			.five1 {
				position: relative;
				margin-left: 40px;

				.five11 {
					div {
						cursor: pointer;
					}
				}

				.five12 {
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #2768b7;
					position: absolute;
					left: 0;
					right: 0;
					text-align: center;
					top: 35%;
				}
			}
		}
	}

	.four {
		width: 100vw;
		padding-top: 112px;
		margin-bottom: 81px;

		.three1 {
			height: 40px;
			line-height: 40px;
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: black;
			text-align: center;
		}

		.three2 {
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #666666;
			text-align: center;
			margin-top: 29px;
		}

		.four3 {
			width: 456px;
			height: 60px;
			background: #fae6cc;
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #f1993a;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			margin-top: 38px;
		}
		.four4s{
			width: 1340px;
			display: flex;
			flex-wrap: wrap;
			margin: 0 auto;
			margin-top: 60px;
			.srcList{
				margin: 0 14px 40px 14px;
				/deep/.el-image{
					width: 306px;
					height: 306px;
				}
				/deep/.el-image-viewer__close{
					margin-top: 80px;
				}
				/deep/.el-icon-circle-close:before{
					color: #fff;
				}
				.name{
					text-align: center;
					font-size: 24px;
					color: #222;
				}
				.position{
					text-align: center;
					font-size: 18px;
					color: #999;
				}
			}
			
		}
		.four4 {
			display: flex;
			align-items: center;
			width: 1340px;
			margin: 0 auto;
			margin-top: 60px;
			// background: red;
			.srcBox{
				// display: flex;
				align-items: center;
				// /deep/.el-image{
				// 	width: 306px;
				// 	height: 306px;
				// }
				/deep/.el-image-viewer__close{
					margin-top: 80px;
				}
				/deep/.el-icon-circle-close:before{
					color: #fff;
				}
			}
			.srcBoxLeft{
				width: 550px;
				margin-right: 35px;
				/deep/.onesrc{
					width: 316px;
					height: 230px;
					margin-right: 25px;
				}
				/deep/.twosrc{
					width: 196px;
					height: 230px;
				}
				/deep/.threesrc{
					width: 196px;
					height: 230px;
					margin-right: 25px;
				}
				/deep/.foursrc{
					width: 316px;
					height: 230px;
				}
			}
			.srcBoxCen{
				width: 306px;
				margin-right: 75px;
				/deep/.onesrc{
					width: 313px;
					width: 340px;
					height: 464px;
					margin-right: 25px;
				}
			}
			.srcBoxRight{
				width: 360px;
				// background: blue;
				// margin-right: 25px;
				/deep/.onesrc{
					width: 360px;
					height: 180px;
					margin-right: 25px;
				}
				/deep/.twosrc{
					width: 360px;
					height: 275px;
				}
			}
			
			.srcList{
				margin-left: 10px;
				margin-left: 10px;
				/deep/.el-image{
					width: 180px;
					height: 180px;
				}
				/deep/.el-image-viewer__close{
					margin-top: 80px;
				}
				/deep/.el-icon-circle-close:before{
					color: #fff;
				}
			}
			.four41 {
				width: 540px;

				.four411 {
					display: flex;
					justify-content: space-between;
					margin-bottom: 24px;

					img:nth-child(1) {
						width: 320px;
						height: 238px;
						margin-right: 20px;
					}

					img:nth-child(2) {
						width: 200px;
						height: 238px;
					}

					img:hover {
						transform: scale(1.4);
					}
				}

				.four412 {
					display: flex;
					justify-content: space-between;

					img:nth-child(1) {
						width: 200px;
						height: 238px;
						margin-right: 20px;
					}

					img:nth-child(2) {
						width: 320px;
						height: 238px;
					}

					img:hover {
						transform: scale(1.4);
					}
				}

				// .four413 {
				//   height: 5%;
				// }
				// .four414 {
				// }
			}

			.four43 {
				margin-left: 20px;
				div{
					// overflow: hidden;
					// background: red;
					img {
						
						width: auto;
						height: auto;
						// max-width: 100%;
						max-height: 100%;
					
					}
				}
				// img {
				// 	width: 340px;
				// 	height: 100%;
				// }

				img:hover {
					transform: scale(1.4);
				}
			}

			.four44 {
				margin-left: 20px;

				.four412{
					width: 396px;
					height: 187px;
					// overflow: hidden;
					img {
						// width: 396px;
						// height: 187px;
						width: auto;
						height: auto;
						max-width: 100%;
						max-height: 100%;
					
					}
				} 
				img:hover {
					transform: scale(1.4);
				}

				.four411 {
					margin-top: 24px;

					img {
						width: 396px;
						height: 289px;
					}

					img:hover {
						transform: scale(1.4);
					}
				}

			}

			.four45 {
				flex: 1;

				margin-left: 20px;
			}

			.four46 {
				flex: 1;

				margin-left: 20px;
			}

			.four42 {
				flex: 1.5;
			}
		}
	}
	.five{
		padding-top: 10px;
	}
</style>
